import { compose } from 'redux'

// higher-order components
import withState from './withState'
import withMutation from './withMutation'
import withEventHandlers from './withEventHandlers'
import withFormResults from 'components/shared/withFormResults'

// presentational components
import UI from './UI'

const withPreferencesFormResults = withFormResults({
  mutation: 'updatePreferences',
  field: 'preferences',
  successMessage: 'Preferences updated'
})

export default compose(
  withState, // for getting/setting form state
  withPreferencesFormResults, // for handling results
  withMutation, // for updating preferences
  withEventHandlers // for form interactions
)(UI)
